module.exports = __webpack_public_path__ + "static/media/React.2c402a3b.png";